<nb-card>
  <nb-card-header
    >Bạn đã hoàn thành khóa học.
    <button
      class="cancel"
      nbButton
      outline
      status="info"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon></button
  ></nb-card-header>
  <nb-card-body [nbSpinner]="loading" nbSpinnerStatus="info">
    <h6 *ngIf="showGift" class="text-primary">
      Bạn nhận được <strong class="text-danger">{{ stars }}</strong>
      <nb-icon
        [status]="'warning'"
        class="action-icon"
        icon="star-outline"
      ></nb-icon>
      ! Xin chúc mừng.
    </h6>

    <ngx-view-image
      *ngIf="showGift == true"
      [imageURL]="imageURL"
      [size]="'small'"
    ></ngx-view-image>

    <div *ngIf="!showGift" class="text-hint">
      Hãy gửi lời cám ơn tới người hướng dẫn nhé!
    </div>
    <form *ngIf="!showGift" [formGroup]="ratingForm">
      <div class="form-group">
        <nb-actions size="tyni">
          <nb-action
            *ngFor="let item of ratingSelects"
            (click)="ratingSelected = item"
          >
            <nb-icon
              *ngIf="item <= ratingSelected"
              [status]="'warning'"
              class="action-icon"
              icon="star"
            ></nb-icon>
            <nb-icon
              *ngIf="item > ratingSelected"
              [status]="'warning'"
              class="action-icon"
              icon="star-outline"
            ></nb-icon>
          </nb-action>
        </nb-actions>
      </div>
      <div class="form-group">
        <input
          type="text"
          nbInput
          fullWidth
          formControlName="title"
          placeholder="Nhập tiêu đề"
          class="form-control"
          [(ngModel)]="title"
        />
      </div>
      <div class="form-group">
        <textarea
          nbInput
          fullWidth
          id="inputDescription"
          placeholder="Nhập mô tả"
          class="form-control"
          formControlName="description"
          [(ngModel)]="description"
        ></textarea>
      </div>
    </form>
  </nb-card-body>
  <nb-card-footer *ngIf="!showGift">
    <button
      type="submit"
      nbButton
      status="primary"
      (click)="submit()"
      [disabled]="submitted || !ratingForm.valid"
      [class.btn-pulse]="submitted"
    >
      <nb-icon
        class="action-icon"
        icon="gift-outline"
        [options]="{ animation: { type: 'zoom' } }"
      ></nb-icon>
      Nhận quà và gửi lời cám ơn
    </button>
  </nb-card-footer>
</nb-card>
